import { createSelector } from 'reselect';
import { every, flatMap, flow, includes, isEmpty, keys, pick } from 'lodash/fp';

import logging from '../../logging';
import selectRawProduct from '../select-raw-product';

const makeSelectHasAllRequiredProductsLoaded = (productList: string[]) =>
  createSelector([selectRawProduct], (products) => {
    const loadedProductIds = flow(pick(['data']), flatMap(keys))(products);
    const allLoaded = every((productId: string) => includes(productId, loadedProductIds), productList);
    // @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'error' does not exist on type 'never'.
    if (!isEmpty(products?.error)) {
      logging.getLogger().error('All required products haven’t loaded', {
        // @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'error' does not exist on type 'never'.
        error: products?.error ?? null,
      });
    }

    // @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'loading' does not exist on type 'never'.
    return (allLoaded && isEmpty(products?.loading ?? false)) || !isEmpty(products?.error ?? null);
  });

export default makeSelectHasAllRequiredProductsLoaded;
